import { createFileRoute, retainSearchParams } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import DocumentList from "@/components/_DocumentList";

// Search params are optional, so we need to set default values
// See: https://tanstack.com/router/latest/docs/framework/react/guide/search-params
const searchSchema = z.object({
  // Firm code is a number, but we need to set a default value of 0 to allow for the case where the firm code is not in the url
  firmcode: fallback(z.coerce.string().min(8), "").default(""),
  email: fallback(z.string().email(), "").default(""),
  lng: fallback(z.enum(["en", "es"]), "en").default("en"),
});

export type SearchSchema = Partial<z.infer<typeof searchSchema>>;

export const Route = createFileRoute("/")({
  component: DocumentList,
  validateSearch: zodValidator(searchSchema),
  search: {
    middlewares: [retainSearchParams(true)],
  },
});
